import {NgModule} from '@angular/core'
import {CommonModule, DecimalPipe} from '@angular/common'
import {RouterModule} from '@angular/router'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {BsDropdownDirective, BsDropdownModule} from 'ngx-bootstrap/dropdown'
import {MissingTranslationHandler, TranslateLoader, TranslateModule} from '@ngx-translate/core'
import {PopoverModule} from 'ngx-bootstrap/popover'
import { HttpBackend, HttpClient } from '@angular/common/http'
import {TranslateHttpLoader} from '@ngx-translate/http-loader'
import {CarouselModule} from 'ngx-bootstrap/carousel'
import {TooltipModule} from 'ngx-bootstrap/tooltip'
import {ModalModule} from 'ngx-bootstrap/modal'
import {AccordionModule} from 'ngx-bootstrap/accordion'
import {PaginationModule} from 'ngx-bootstrap/pagination'
import {TabsModule} from 'ngx-bootstrap/tabs'
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker'
import {HeaderComponent} from './components/header/header.component'
import {SidebarComponent} from './components/sidebar/sidebar.component'
import {CollapseModule} from 'ngx-bootstrap/collapse'
import {IfHasAllPermissionsDirective} from './directives/if-has-all-permissions.directive'
import {ContentHeaderComponent} from './components/content-header/content-header.component'
import {TimepickerModule} from 'ngx-bootstrap/timepicker'
import {FormGroupComponent} from './components/form-inputs/form-group/form-group.component'
import {TableComponent} from './components/table/table.component'
import {CdkDrag, CdkDragHandle, CdkDropList} from '@angular/cdk/drag-drop'
import {NgxNavbarModule} from 'ngx-bootstrap-navbar'
import {ToastrModule} from 'ngx-toastr'
import {IfHasAnyPermissionDirective} from './directives/if-has-any-permission.directive'
import {QuillModule} from "ngx-quill";
import {DateFnsModule} from "ngx-date-fns";
import {DeleteCardComponent} from "./components/form-inputs/delete-card/delete-card.component";
import {StateCardComponent} from "./components/form-inputs/state-card/state-card.component";
import {ImageCardComponent} from "./components/form-inputs/image-card/image-card.component";
import {FileManagerComponent} from "./components/file-manager/file-manager.component";
import {FolderComponent} from "./components/file-manager/folder/folder.component";
import {AngularSplitModule} from "angular-split";
import {ContextMenuModule} from "@perfectmemory/ngx-contextmenu";
import {DndModule} from "ngx-drag-drop";
import {NgxDropzoneModule} from "ngx-dropzone";
import {AttachmentsCardComponent} from "./components/form-inputs/attachments-card/attachments-card.component";
import {TabSwitcherComponent} from "./components/tab-switcher/tab-switcher.component";
import {
  MultiSelectWithServiceComponent
} from "./components/form-inputs/multi-select-with-service/multi-select-with-service.component";
import {AutosizeModule} from "ngx-autosize";
import {ClipboardModule} from "ngx-clipboard";
import {
  MultiSelectWithStaticOptionsStaticComponent
} from "./components/form-inputs/multi-select-static-with-static-options/multi-select-with-static-options-static.component";
import {ColorPickerModule} from "ngx-color-picker";
import {CurrencyInputComponent} from "./components/form-inputs/currency-input/currency-input.component";
import {AnonymizeCardComponent} from "./components/form-inputs/anonymize-card/anonymize-card.component";
import {TableFilterComponent} from './components/table-filter/table-filter.component';
import {NgxDatatableModule} from "@siemens/ngx-datatable";
import {IntFilterComponent} from './components/table-filter/int-filter/int-filter.component';
import {TimeRangeFilterComponent} from './components/table-filter/time-range-filter/time-range-filter.component';
import {DateFilterComponent} from "./components/table-filter/date-filter/date-filter.component";
import {MultiSelectEnumComponent} from "./components/form-inputs/multi-select-enum/multi-select-enum.component";
import {TableDataComponent} from './components/table/table-data/table-data.component';
import {TableColumnSorterComponent} from "./components/table/table-column-sorter/table-column-sorter.component";
import {TablePaginationComponent} from './components/table/table-pagination/table-pagination.component';
import {TableFilterLoaderComponent} from './components/table/table-filter-loader/table-filter-loader.component';
import {
  MultiSelectWithServiceIdArrayComponent
} from "./components/form-inputs/multi-select-with-service-id-array/multi-select-with-service-id-array.component";
import {MoneyFilterComponent} from "./components/table-filter/money-filter/money-filter.component";
import {MarkdownEditorComponent} from "./components/form-inputs/markdown-editor/markdown-editor.component";
import {EmailPlaceholdersComponent} from "./components/email-placeholders/email-placeholders.component";
import {DateTimeSelectorComponent} from "./components/form-inputs/date-time-selector/date-time-selector.component";
import {LowestNumberPipe} from "./pipes/lowest-number.pipe";
import {
  InputOnlyNumberComponent
} from "./components/form-inputs/input-only/input-only-number/input-only-number.component";
import {CountrySelectorComponent} from "./components/form-inputs/country-selector/country-selector.component";

import {FormatInTimeZonePipe} from "./pipes/format-in-time-zone.pipe";
import {
  ReadOnlyWithServiceComponent
} from "./components/form-inputs/read-only-with-service/read-only-with-service.component";
import {TransformObjectToKeyValueArrayPipe} from "./pipes/transform-object-to-key-value-array.pipe";
import {GetContingentStatusCssClassPipe} from "./pipes/get-contingent-status-css-class.pipe";
import {ObjectArrayContainsValuePipe} from "./pipes/object-array-contains-value.pipe";
import {BackButtonComponent} from "./components/back-button/back-button.component";
import {ShouldShowColumnPipe} from "./pipes/should-show-column.pipe";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";
import {NgxCurrencyDirective} from "ngx-currency";
import {EmailBuilderModalComponent} from "./components/email-sender/email-builder-modal.component";
import {CurrentDateWithinDateRangePipe} from "./pipes/current-date-within-date-range.pipe";
import {NgxEchartsDirective, provideEchartsCore} from "ngx-echarts";
import {
  StaticDateRangeFilterComponent
} from "./components/table-filter/static-date-range-filter/static-date-range-filter.component";
import {ConvertAnswerOptionsToSelectOptionsPipe} from "./pipes/convert-answer-options-to-select-options.pipe";
import {ConvertEnumToSelectOptionsPipe} from "./pipes/convert-enum-to-select-options.pipe";
import {IfHasAllAndAnyPermissionsDirective} from "./directives/if-has-all-and-any-permissions.directive";
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from "ngx-webstorage";
import * as echarts from 'echarts/core';
import {BarChart} from "echarts/charts";
import {GraphicComponent, GridComponent, LegendComponent, TitleComponent, TooltipComponent} from "echarts/components";
import {CanvasRenderer} from "echarts/renderers";
import {FileSizePipe} from "./pipes/filesize.pipe";
import {DatePickerModule} from "primeng/datepicker";
import {BugsnagMissingTranslationHandlerService} from "../../services/bugsnag-missing-translation-handler.service";
import {ParseMinMaxDatePipe} from "./pipes/parse-min-max-date.pipe";
echarts.use([BarChart, GridComponent, CanvasRenderer, LegendComponent, TitleComponent, TooltipComponent, GraphicComponent]);


// AoT requires an exported function for factories
// httpBackend is used to init a new HttpClient instead of using the present one
// Using the already present HttpClient causes a Circular dependency
export function createTranslateLoader(httpBackend: HttpBackend) {
  return new TranslateHttpLoader(new HttpClient(httpBackend), 'assets/i18l/', '.json')
}

const SHARED_MODULES = [
  CommonModule,
  RouterModule,
  ModalModule.forRoot(),
  FormsModule,
  ReactiveFormsModule,
  TooltipModule,
  AccordionModule.forRoot(),
  BsDropdownModule.forRoot(),
  BsDropdownDirective,
  PopoverModule.forRoot(),
  CarouselModule.forRoot(),
  TranslateModule.forChild({
    useDefaultLang: true,
    missingTranslationHandler: {provide: MissingTranslationHandler, useClass: BugsnagMissingTranslationHandlerService},
    isolate: false,
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [HttpBackend]
    }
  }),
  PaginationModule,
  TabsModule,
  BsDatepickerModule.forRoot(),
  CollapseModule.forRoot(),
  TimepickerModule,
  CdkDrag,
  CdkDropList,
  CdkDragHandle,
  QuillModule.forRoot(),
  NgxNavbarModule,
  ToastrModule.forRoot({
    countDuplicates: true,
    tapToDismiss: false,
    closeButton: true,
    maxOpened: 3,
    progressBar: false,
    progressAnimation: 'decreasing',
    enableHtml: true,
    preventDuplicates: true,
    resetTimeoutOnDuplicate: true,
  }),
  DateFnsModule.forRoot(),
  AngularSplitModule,
  ContextMenuModule,
  DndModule,
  NgxDropzoneModule,
  AutosizeModule,
  ClipboardModule,
  ColorPickerModule,
  NgxDatatableModule,
  DatePickerModule,
  NgxEchartsDirective,
]

const SHARED_COMPONENTS = [
  HeaderComponent,
  SidebarComponent,
  ContentHeaderComponent,
  FormGroupComponent,
  TableComponent,
  DeleteCardComponent,
  AnonymizeCardComponent,
  ImageCardComponent,
  AttachmentsCardComponent,
  StateCardComponent,
  FileManagerComponent,
  FolderComponent,
  TabSwitcherComponent,
  MultiSelectWithServiceComponent,
  MultiSelectWithServiceIdArrayComponent,
  MultiSelectWithStaticOptionsStaticComponent,
  CurrencyInputComponent,
  TableFilterComponent,
  IntFilterComponent,
  TimeRangeFilterComponent,
  MoneyFilterComponent,
  DateFilterComponent,
  MultiSelectEnumComponent,
  MarkdownEditorComponent,
  EmailPlaceholdersComponent,
  DateTimeSelectorComponent,
  InputOnlyNumberComponent,
  CountrySelectorComponent,
  ReadOnlyWithServiceComponent,
  BackButtonComponent,
  EmailBuilderModalComponent,
  TableFilterLoaderComponent,
  StaticDateRangeFilterComponent,
  TableDataComponent,
  TableColumnSorterComponent,
  TablePaginationComponent,
  TableFilterLoaderComponent,
]

const SHARED_PIPES = [
  LowestNumberPipe,
  FormatInTimeZonePipe,
  TransformObjectToKeyValueArrayPipe,
  GetContingentStatusCssClassPipe,
  ObjectArrayContainsValuePipe,
  ShouldShowColumnPipe,
  CurrentDateWithinDateRangePipe,
  ConvertAnswerOptionsToSelectOptionsPipe,
  ConvertEnumToSelectOptionsPipe,
  FileSizePipe,
  ParseMinMaxDatePipe
]

const SHARED_DIRECTIVES = [
  IfHasAllPermissionsDirective,
  IfHasAnyPermissionDirective,
  IfHasAllAndAnyPermissionsDirective,
]


@NgModule({
  declarations: [],
  imports: [
    SHARED_MODULES,
    SHARED_COMPONENTS,
    NgMultiSelectDropDownModule,
    NgxCurrencyDirective,
    SHARED_PIPES,
    SHARED_DIRECTIVES
  ],
  exports: [
    SHARED_MODULES,
    SHARED_COMPONENTS,
    SHARED_PIPES,
    SHARED_DIRECTIVES
  ],
  providers: [
    DecimalPipe,
    provideNgxWebstorage(
      withLocalStorage(),
      withSessionStorage()
    ),
    provideEchartsCore({ echarts })
  ]
})
export class SharedModule {
}
